import { render, staticRenderFns } from "./RegisterCompanyDataStep.vue?vue&type=template&id=ca9c967c&scoped=true"
import script from "./RegisterCompanyDataStep.vue?vue&type=script&lang=js"
export * from "./RegisterCompanyDataStep.vue?vue&type=script&lang=js"
import style0 from "./RegisterCompanyDataStep.vue?vue&type=style&index=0&id=ca9c967c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca9c967c",
  null
  
)

export default component.exports